export default __webpack_public_path__ + "static/Why-Choose-f1488b0a87a2a43f65a0cdc14d662dba.webp";